module.exports = __webpack_public_path__ + "img/step2.5f6222e2.png";